import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1653657405722'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='10807'
    >
        <path
            d='M619.4 990.5c-143.8 0-283.5 1.5-423.1-0.6-85-1.3-167.9-87-168.5-174.2-1.6-207-1.5-414.1-0.1-621.1 0.6-89.1 81.6-173 170.4-174.3 171.2-2.4 342.5-2.6 513.8-0.3 91.7 1.2 172 80.6 174.9 172.6 3.4 103.7 0.8 207.7 0.8 313-159.6-53.3-284.3-13-361.8 138.6-49.6 97.1-38.1 242 93.6 346.3z m-159.5-788c-76.4 0-152.8-0.2-229.2 0.1-31.7 0.1-50.5 14.7-51.5 38.8-1 24 17.3 41 48.9 41.1 152.8 0.6 305.6 0.4 458.4-0.1 11 0 26.3-2.3 31.9-9.6 8.5-11 15.8-28 13.8-41-3.2-21.1-21.5-29.4-43.1-29.4-76.4 0.2-152.8 0.1-229.2 0.1zM350.2 469.7c43.3 0 86.5 0.2 129.8-0.1 27.1-0.2 44.9-16.5 44.4-39.6-0.5-22.2-17.9-38.2-43.7-38.3-84.8-0.3-169.7-0.3-254.5 0-28.9 0.1-47.5 16.6-46.9 40.2 0.5 23.2 17.8 37.6 46.2 37.8 41.6 0.2 83.2 0 124.7 0z m-74.8 358.5v-0.1c19.9 0 39.9 1.1 59.7-0.3 23.6-1.6 40.8-19.1 40.9-39.1 0.1-19.1-15.5-38-38-38.9-41.3-1.7-82.8-1.5-124.1 0.7-22.3 1.2-35.4 19.4-34.8 40.7 0.6 20.8 15.5 35.6 39.1 36.8 19 1 38.1 0.2 57.2 0.2z m-0.1-189.1c19.9 0 39.8 0.7 59.6-0.2 23.2-1 40.8-18 41.1-38.3 0.4-21.5-17.7-38.9-42.5-39.3-38.1-0.6-76.2-0.5-114.2 0-23.2 0.3-39.8 16.9-40.1 38.3-0.3 22.1 15.4 38.5 39 39.4 19 0.7 38.1 0.1 57.1 0.1z'
            p-id='10808'
            fill='currentColor'
        ></path>
        <path
            d='M766.8 990.9c-123.8 0.4-224.6-103.4-225.5-230.8-0.9-127 104-234.6 226-232.8C893.4 529.2 995 629 996.5 758.1c1.5 127-102.5 232.4-229.7 232.8zM728 716.1c0 18.3-0.6 36.6 0.3 54.9 0.3 7 2.1 15.6 6.5 20.4 28.5 30.2 57.3 60.2 87.4 88.8 16.1 15.3 34.2 10 44.7-9.7 10.3-19.3-0.1-33.5-13.7-43-59.5-41.4-74.4-98.7-64.5-166.9 3-20.9-10.2-35.4-28.9-35.3-21.5 0.1-31.2 13.2-31.8 33.5-0.4 19.1 0 38.2 0 57.3z'
            p-id='10809'
            fill='currentColor'
        ></path>
    </svg>
)

export const ActivityDiaryIcon = props => <Icon component={SVG} {...props} />
